import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BlogCard = ({ className, limit }) => {
  const { t } = useTranslation();
  const blogData = [
    {
      title: t('sections.blogCard.blogs.0.title','Top Cybersecurity Trends to Watch in 2024'),
      img: 'assets/img/blog/blog_1_1.jpg',
      date: 'December 26',
      detailsLink: "/blog/top-cybersecurity-trends-2024",
    },
    {
      title: t('sections.blogCard.blogs.1.title','AI in Cybersecurity: A Double-Edged Sword?'),
      img: 'assets/img/blog/blog_1_2.jpg',
      date: 'March 05',
      detailsLink: "/blog/ai-in-cybersecurity", 
    },
    {
      title: t('sections.blogCard.blogs.2.title','The Ultimate Guide to Creating Strong Passwords'),
      img: 'assets/img/blog/blog_1_3.jpg',
      date: 'April 15',
      detailsLink: "/blog/strong-password-guide",
    }
  ];

  const currentYear = new Date().getFullYear();
  const displayBlogs = limit !== undefined ? blogData.slice(0, limit + 1) : blogData;

  return (
    <>
      {displayBlogs.map((blog, index) => (
        <div className={className} key={index}>
          <div className="blog-card" data-cue="slideInUp">
            <div className="blog-img">
              <img src={blog.img} alt={blog.title} />
            </div>
            <div className="blog-content">
              <div className="blog-meta">
                <Link to="/blog">{blog.date} , {currentYear}</Link>
              </div>
              <h3 className="box-title">
                <Link to={blog.detailsLink}>{blog.title}</Link>
              </h3>
              <Link to={blog.detailsLink} className="link-btn style-gradient">
                {t('sections.blogCard.read_more','Read More')} <i className="far fa-long-arrow-right ms-2" />
              </Link>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BlogCard;